import { gql } from '@apollo/client'
import { BodyText, Button, Heading, Link } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import classNames from 'classnames'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { UpdatePaymentInfoLockContent_OfferLockDataFragment } from './__generated__/content.graphql'
import styles from './update-payment-info-lock.module.scss'

interface ContentProps {
  offerLockData: UpdatePaymentInfoLockContent_OfferLockDataFragment
}

export function Content({ offerLockData }: ContentProps) {
  const context = useContext(BoxLockContext)
  const isPaywall = context.componentType === 'paywall'

  if (!offerLockData.body.cards.length) {
    return null
  }

  const imageClassNames = classNames(styles.image, {
    [styles.imagePaywall]: isPaywall,
  })

  const { body, header } = offerLockData
  const [card] = body.cards
  const { src, alt } = card.image

  const title = header.title
  const [descriptionOne, descriptionTwo] = card.descriptions
  const linkLabel = card.link.label
  const buttonLabel = card.button.label
  const buttonUrl = card.button.url
  const linkUrl = card.link.url

  return (
    <>
      {src && <Image className={imageClassNames} alt={alt} src={src} width={161} height={160} />}
      <Heading className={styles.heading} size="md" asChild>
        <h3>{title}</h3>
      </Heading>
      <div className={styles.descriptionContainer}>
        <BodyText size="lg" className={styles.descriptions}>
          <span>{descriptionOne}</span>
        </BodyText>
        <BodyText size="lg">
          <span>
            {descriptionTwo}{' '}
            <Link type="secondary" href={linkUrl} target="_blank" rel="noopener noreferrer">
              {linkLabel}
            </Link>
          </span>
        </BodyText>
      </div>

      {isPaywall && (
        <footer className={styles.footer}>
          <Button kind="secondary" asChild>
            <a href={buttonUrl} target="_blank" rel="noopener noreferrer">
              {buttonLabel}
            </a>
          </Button>
        </footer>
      )}
    </>
  )
}

Content.fragments = {
  offerLockData: gql`
    fragment UpdatePaymentInfoLockContent_offerLockData on OfferLockData {
      header {
        title
      }
      body {
        cards {
          descriptions
          button {
            label
            url
          }
          link {
            label
            url
          }
          image {
            alt
            src
          }
        }
      }
    }
  `,
}
